<template>
  <a-drawer width="70%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
     <a-form-model ref="form" :model="form" :rules="rules"> 
      <a-form-model-item label="BMI等级" prop="bmiLevel">
        <a-select v-model="form.bmiLevel">
          <a-select-option v-for="item in bmiCategory" :value="item.dictValue" :key='item.dictValue'>{{item.dictLabel}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="最低体重(斤)" prop="weightLowest">
        <a-input-number :min="1" v-model="form.weightLowest"></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="最高体重(斤)" prop="weightHighest">
        <a-input-number :min="1" v-model="form.weightHighest"></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="最低身高(厘米)" prop="heightLowest">
        <a-input-number :min="1" v-model="form.heightLowest" />
      </a-form-model-item>
      <a-form-model-item label="最高身高(厘米)" prop="heightHighest">
        <a-input-number :min="1" v-model="form.heightHighest"></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="评分" prop="score">
        <a-input-number :min="1" :max="5" v-model="form.score"></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="计划类型" prop="planType">
        <a-select v-model="form.planType">
          <a-select-option v-for="item in planTypeCategory" :value="item.id" :key='item.id'>{{item.dictLabel}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="标题" prop="title">
        <a-input v-model="form.title" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="副标题" prop="subTitle">
        <a-input v-model="form.subTitle" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="计划封面" prop="image">
        <file-upload v-model="form.image" :default-list="form.imageArr" type="image"  :imgSize="'690*380'"
          @input="getImg($event, 'image')"></file-upload>
      </a-form-model-item>
      <a-form-model-item label="介绍" prop="introduce">
        <file-upload v-model="form.introduce" :default-list="form.introduceArr" type="image"
          @input="getImg($event, 'introduce')"></file-upload>
      </a-form-model-item>
      <a-form-model-item label="计划须知" prop="planNotice">
        <editor v-model="form.planNotice" />
      </a-form-model-item>
      <a-form-model-item label="是否推荐" prop="isRecommend">
        <a-select v-model="form.isRecommend">
          <a-select-option :value="0">否</a-select-option>
          <a-select-option :value="1">是</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="是否私人定制" prop="createType">
        <a-select v-model="form.createType">
          <a-select-option :value="0">否</a-select-option>
          <a-select-option :value="1">是</a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- 分页信息 -->
      <a-form-model-item label="食谱日期">
        <a-table :loading="loading" :size="tableSize" rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 400px)'}" :columns="columns" :data-source="list"
          :pagination="false" :bordered="tableBordered">
        </a-table>
        <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
          :total="total" :page-size="queryParam.pageSize" :showTotal="total => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange" @change="changeSize" />
      </a-form-model-item>
      <!-- 分页 -->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>

</template>

<script>
  import {
    getPlan,
    addPlan,
    updatePlan
  } from '@/api/cookbook/plan'
  import {
    pageDayInfo,
    listDayInfo,
    delDayInfo
  } from '@/api/plan/dayInfo'
  import {
    tableMixin
  } from '@/store/table-mixin'
  import {
    getDicts
  } from "@/api/system/dict/data";
  import {
    guid
  } from "@/utils/ruoyi";
  import Editor from "@/components/Editor/Editor";

  export default {
    name: 'CreateForm',
    props: {},
    components: {
      Editor
    },
    mixins: [tableMixin],
    data() {
      return {
        total: 0,
        // 查询参数
        queryParam: {
          planId: null,
          seq: null,
          type: null,
          content: null,
          kilocalorie: null,
          proteinWeight: null,
          proteinRatio: null,
          carbohydrateWeight: null,
          carbohydrateRatio: null,
          fatWeight: null,
          fatRatio: null,
          breakfast: null,
          lunch: null,
          dinner: null,
          pageNum: 1,
          pageSize: 10
        },
        selectedRowKeys: [],
        list: [],
        columns: [
          {
            title: '计划标题',
            dataIndex: 'title',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '千卡',
            dataIndex: 'kilocalorie',
            ellipsis: true,
            align: 'center',
            width: '8%'
          },
          {
            title: '蛋白质份量g',
            dataIndex: 'proteinWeight',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '蛋白质含量%',
            dataIndex: 'proteinRatio',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '碳水化合物份量',
            dataIndex: 'carbohydrateWeight',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '碳水化合物含量%',
            dataIndex: 'carbohydrateRatio',
            ellipsis: true,
            align: 'center',
            width: '10%'
          },
          {
            title: '脂肪份量g',
            dataIndex: 'fatWeight',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '脂肪含量%',
            dataIndex: 'fatRatio',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '是否准备日',
            dataIndex: 'type',
            ellipsis: true,
            align: 'center',
            customRender: function(e) {
              if (e === 0) {
                return "否";
              } else if (e === 1) {
                return "是";
              }
            }
          },
          {
            title: '排序',
            dataIndex: 'seq',
            ellipsis: true,
            align: 'center'
          }
        ],
        loading: false,
        submitLoading: false,
        formTitle: '',
        bmiCategory: [],
        planTypeCategory: [],
        // 表单参数
        form: {
          id: null,

          bmiLevel: null,

          // 体重最低值
          weightLowest: 1,
          // 体重最高值
          weightHighest: null,
          weight: null,

          // 身高最低值
          heightLowest: null,
          // 身高最高值
          heightHighest: null,
          height: null,
          imageArr: [],
          introduceArr: [],

          score: null,

          planType: null,

          title: null,

          subTitle: null,

          image: null,

          introduce: null,

          planNotice: null,

          joinNum: null,

          isRecommend: null,

          createType: null,

          createTime: null,

          remark: null,

        },
        // 1增加,2修改
        formType: 1,
        open: false,
        rules: {
          bmiLevel: [{
            required: true,
            message: 'BMI等级 1-偏轻 2-正常 3-偏胖不能为空',
            trigger: 'blur'
          }],
          weightHighest: [{
            required: true,
            message: '最高体重不能为空',
            trigger: 'blur'
          }],
          weightLowest: [{
            required: true,
            message: '最低体重不能为空',
            trigger: 'blur'
          }],

          /*height: [
            { required: true, message: '身高区间  1-2不能为空', trigger: 'blur' }
          ],*/
          heightLowest: [{
            required: true,
            message: '最低身高不能为空',
            trigger: 'blur'
          }],
          heightHighest: [{
            required: true,
            message: '最高身高不能为空',
            trigger: 'blur'
          }],
          score: [{
            required: true,
            message: '评分不能为空',
            trigger: 'blur'
          }],
          planType: [{
            required: true,
            message: '计划类型 字典表｛plan_type.id｝不能为空',
            trigger: 'change'
          }],
          title: [{
            required: true,
            message: '标题不能为空',
            trigger: 'blur'
          }],
          subTitle: [{
            required: true,
            message: '副标题不能为空',
            trigger: 'blur'
          }],
          image: [{
            required: true,
            message: '计划封面不能为空',
            trigger: 'blur'
          }],
          introduce: [{
            required: true,
            message: '介绍不能为空',
            trigger: 'blur'
          }],
          planNotice: [{
            required: true,
            message: '计划须知不能为空',
            trigger: 'blur'
          }],
          isRecommend: [{
            required: true,
            message: '是否推荐 0-否 1-是不能为空',
            trigger: 'blur'
          }],
          createType: [{
            required: true,
            message: '是否私人定制 0-否 1-是不能为空',
            trigger: 'change'
          }]
        }
      }
    },
    filters: {},
    created() {
      this.initDict()
    },
    computed: {},
    watch: {},
    mounted() {},
    methods: {
      onClose() {
        this.open = false
      },
      /** 获取字典信息 **/
      initDict() {
        getDicts('bmi_level').then(res => {
          this.bmiCategory = res.data
        })
        getDicts('plan_type').then(res => {
          this.planTypeCategory = res.data
        })
      },
      // 取消按钮
      cancel() {
        this.open = false
        this.reset()
      },
      // 表单重置
      reset() {
        this.list = null,
        console.log('进入表单重置')
        this.formType = 1
        this.form = {
          id: null,
          bmiLevel: null,
          weight: null,
          height: null,
          score: null,
          // 身高最低值
          heightLowest: null,
          // 身高最高值
          heightHighest: null,
          // 体重最低值
          weightLowest: null,
          // 体重最高值
          weightHighest: null,
          imageArr: [],
          introduceArr: [],
          planType: null,
          title: null,
          subTitle: null,
          image: null,
          introduce: null,
          planNotice: null,
          joinNum: null,
          isRecommend: null,
          createType: null,
          createTime: null,
          remark: null,
        }
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.resetFields()
          }
        })
      },
      /** 新增按钮操作 */
      handleAdd(row) {
        this.reset()
        this.open = true

        this.formType = 1

        this.formTitle = '添加'
      },
      /** 修改按钮操作 */
      handleUpdate(row, ids) {
        this.reset()
        this.formType = 2
        const id = row ? row.id : ids
        let that = this
        getPlan({
          "id": id
        }).then(response => {
          this.form = response.data
          this.open = true
          if (this.form.bmiLevel) {
            this.form.bmiLevel = this.form.bmiLevel + ''
          }
          if (this.form.height) {
            this.form.heightLowest = this.form.height.split("-")[0]
            this.form.heightHighest = this.form.height.split("-")[1]
          }
          if (this.form.weight) {
            this.form.weightLowest = this.form.weight.split("-")[0]
            this.form.weightHighest = this.form.weight.split("-")[1]
          }
          this.form.imageArr = []
          this.form.introduceArr = []
          this.form.imageArr.push({
            uid: guid(8, 10),
            name: that.form.image,
            status: 'done',
            halfUrl: that.form.image,
            url: that.form.image,
            path: that.form.image
          })
          this.form.introduceArr.push({
            uid: guid(8, 10),
            name: that.form.introduce,
            status: 'done',
            halfUrl: that.form.introduce,
            url: that.form.introduce,
            path: that.form.introduce
          })
          this.formTitle = '修改'
          this.queryParam.planId = this.form.id
          this.getList();
        })
      },
      /**上传图片成功回调 */
      getImg(info, fieldName) {
        console.log('info', info)
        if (info.length === 0) {
          this.form[fieldName] = ''
          this.form[`${fieldName}Arr`] = []
        } else {
          if (this.form[`${fieldName}Count`] === 1) {
            this.form[fieldName] = info[0].url
            this.form[`${fieldName}Arr`] = info
          } else {
            this.form[fieldName] = info.map(ele => {
              return ele.url
            }).join(",")
            this.form[`${fieldName}Arr`] = info
          }
        }
      },
      /** 查询食谱计划日期详情列表 */
      getList() {
        this.loading = true
        pageDayInfo(this.queryParam).then(response => {
          this.list = response.data.records
          this.total = response.data.total
          this.current = response.data.current
          this.size = response.data.size
          this.loading = false
        })
      },
      onSelectChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
        this.ids = this.selectedRows.map(item => item.id)
        this.single = selectedRowKeys.length !== 1
        this.multiple = !selectedRowKeys.length
      },
      changeSize (current, pageSize) {
        this.queryParam.pageNum = current
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      // 变化时触发放方法
      onShowSizeChange (current, pageSize) {
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      /** 提交按钮 */
      submitForm: function() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true
            if (this.form.weightHighest < this.form.weightLowest) {
              this.$message.warn(
                '最低体重不能大于最高体重',
                3
              )
              this.submitLoading = false
              return false
            }
            if (this.form.heightHighest < this.form.heightLowest) {
              this.$message.warn(
                '最低身高不能大于最高身高',
                3
              )
              this.submitLoading = false
              return false
            }
            this.form.weight = this.form.weightLowest + "-" + this.form.weightHighest
            this.form.height = this.form.heightLowest + "-" + this.form.heightHighest
            if (this.form.id !== undefined && this.form.id !== null) {
              updatePlan(this.form).then(response => {
                this.$message.success(
                  '修改成功',
                  3
                )
                this.open = false
                this.$emit('ok')
              }).finally(() => {
                this.submitLoading = false
              })
            } else {
              addPlan(this.form).then(response => {
                this.$message.success(
                  '新增成功',
                  3
                )
                this.open = false
                this.$emit('ok')
              }).finally(() => {
                this.submitLoading = false
              })
            }
          } else {
            return false
          }
        })
      }
    }
  }
</script>